import { BOOTSTRAP_LOAD_ERROR_EVENT_TYPE } from './consts';
/* Type-only on purpose: `dynatrace.ts` imports `report` from
 * `@adsk/exo-skeleton-api` at module scope, and a value-syntax import would
 * pull that package into the entry chunk if the build ever stopped dropping
 * the unused binding. */
import type { DynatraceAPI } from './utils/dynatrace/dynatrace';
import { DT_MONITORING_CONTEXT_KEY } from './utils/monitoringContext/monitoringContext';

declare global {
  interface Window {
    /* Optional on purpose: only defined when the HTML shell came from
     * `generateStaticLoader`. */
    __exoRenderStaticLoadError?: (isTerminalFailure?: boolean) => void;
    __exoClearStaticLoadError?: () => void;
    dynatrace?: DynatraceAPI;

    // used to store monitoring context for dynatrace that don't have a built-in API to set it up
    [DT_MONITORING_CONTEXT_KEY]: Record<
      string,
      string | number | boolean | undefined | null
    >;
  }
}

void import('./envs/envConfig')
  .then(({ loadEnvConfig }) => loadEnvConfig())
  .catch(() => undefined);

void import(/* webpackChunkName: "bootstrap" */ './bootstrap').then(
  () => {
    window.__exoClearStaticLoadError?.();
  },
  (error: unknown) => {
    /* `report` would pull `@adsk/exo-skeleton-api` into the entry chunk and undo
     * the split, so talk to the RUM agent directly — it is in the shell before
     * this runs. */
    window.dynatrace?.sendEvent({
      type: BOOTSTRAP_LOAD_ERROR_EVENT_TYPE,
      message: error instanceof Error ? error.message : String(error),
    });
    window.__exoRenderStaticLoadError?.(true);
  },
);

export {};
